import type { UmInAppNotification, UmNotificationSection } from '@/userManagement/domain/entities/UmHeaderContext';

/** Wire shape for GET /notifications until BE adds response schema to OpenAPI. */
export interface UmNotificationDto {
  id?: number;
  kind?: string | null;
  title?: string | null;
  body?: string | null;
  message?: string | null;
  linkUrl?: string | null;
  occurredAt?: string | null;
  createdAt?: string | null;
  approvalRequestId?: number | null;
  section?: string | null;
  type?: string | null;
  isRead?: boolean | null;
}

export interface UmNotificationsListDto {
  notifications?: UmNotificationDto[] | null;
  totalCount?: number | null;
  unreadCount?: number | null;
}

function readSection(dto: UmNotificationDto): UmNotificationSection {
  const raw = (dto.section ?? dto.type ?? dto.kind ?? '').toLowerCase();
  if (raw.includes('informational') || raw.startsWith('targetuser')) {
    return 'informational';
  }
  if (raw.includes('action') || raw.includes('required')) {
    return 'actionRequired';
  }
  return 'actionRequired';
}

export function mapUmNotificationDtoToInApp(dto: UmNotificationDto): UmInAppNotification {
  const id = typeof dto.id === 'number' ? dto.id : Number(dto.id);
  const occurredAt = dto.occurredAt ?? dto.createdAt ?? new Date().toISOString();
  const body = dto.body ?? dto.message ?? '';

  return {
    id: Number.isFinite(id) ? id : 0,
    kind: dto.kind?.trim() || 'Unknown',
    section: readSection(dto),
    title: dto.title?.trim() || 'Notification',
    body: body.trim(),
    occurredAt,
    linkUrl: dto.linkUrl?.trim() || null,
    approvalRequestId: typeof dto.approvalRequestId === 'number' ? dto.approvalRequestId : null,
    isRead: Boolean(dto.isRead)
  };
}
